import React from 'react';
import { useExcelData } from '../../hooks/useExcelData';

//types
import { ComparingCandidateData, Data } from '../../types/types';

//components
import Loading from '../common/Loading';
import ComparingContent from './ComparingContent';

type ComparingProps = ComparingCandidateData

const Comparing = ({ slugParty1, slugParty2 }: ComparingProps) => {

    const { data, loading }: Data = useExcelData();

    return (
        <>
            {loading 
                ? <Loading heightLoading="vh-100" />
                : <ComparingContent 
                    data={data}     
                    slugParty1={slugParty1} 
                    slugParty2={slugParty2} 
                />
            }
        </>   
    )
}

export default Comparing;